import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { getToken } from '../utils/app.utils';


// this is function to accept private route => getToken();const dispatch = useDispatch();
const token = getToken();

interface authenticationProps {
    token: string;
    isAccept: boolean;
}
const PrivateRoute = () => {
    const isAuthentication = useSelector((state: any) => state.token?.accessToken);
    let auth: authenticationProps = { token: isAuthentication, isAccept: !!token };

    return (
        auth.isAccept ? <Outlet /> : <Navigate to="/" />
    )
}

export default PrivateRoute
